import type { LinkedSessionQuery } from 'services/KicodeService';
import { codeStepResourcePath } from 'ts-components/PiChat/kicodeSessions';

export const codeStepResumeQuery = (
  automationId: string,
  stepId: string,
  employeeId: string | null | undefined
): LinkedSessionQuery | null =>
  employeeId
    ? {
        resourcePath: codeStepResourcePath(automationId, stepId),
        builder: 'codestep',
        createdBy: employeeId,
      }
    : null;
